import React from 'react';
import { connect } from 'react-redux';
import { verificarEmail } from './services.act.js'
import { movil } from '../app-movil';
import { authentication } from '../app-database';
import isMobile from 'ismobilejs';

// import PolizaForm from './poliza.frm';

const mapState = (state) => {
    return {
        error: state.olvide.flagError,
        mensaje: state.olvide.errorMsj,
        loader: state.global.loader
    };
}

const mapDispatch = (dispatch) => {
    return {
        verificarEmail: (correo) => {
            dispatch({ "type": "LOGIN_SET_CORREO", 
                      "correo" : correo
                  });
            dispatch({ "type": "RECUPERAR_SET_FLAG_ERROR", 
                      "flag" : false
                  });
            dispatch(verificarEmail(correo));
        },
        showLoading: () => {
            dispatch({ "type": "LOADER_SHOW"});
        },
        clearError: () => {
            dispatch({ "type": "OLVIDE_SET_FLAG_ERROR", 
                      "flag" : false
                  });
        }
        
    }
}

class IngresaCorreo extends React.Component {
    
    state = {
        inputType: "password",
        inputClass: "input-wrap ver-input mt-70",
        inputActive: "",
        error: false,
        errorMsj: this.props.mensaje,
        email: "",
        checkFlag: false,
        bloqueado: false
    }
    
    validateEmail = (email) => {
        var pattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return pattern.test(email); 
    }
    changeInputType = () => {
        let type = this.state.inputType;
        this.setState({inputType: type == 'password' ? 'text' : 'password'});
        this.setState({inputClass: type == 'password' ? 'input-wrap visible-input mt-70' : 'input-wrap ver-input mt-70'});
    }
    validarEmail = () => {
        console.log("Entro a validar email");
        this.setState({bloqueado: true});
        this.setState({checkFlag: true});
        if(!this.props.loader && !this.state.bloqueado){
            let email = this.refs.email.value;
            if(!email) {
                this.setState({error: true});
                this.setState({errorMsj: "Campo requerido."});
                this.setState({bloqueado: false});
            }
            else if(!this.validateEmail(email)) {
                this.setState({error: true});
                this.setState({errorMsj: "El correo electrónico no es válido. Favor de verificar."});
                this.setState({bloqueado: false});
            }
            else {
                this.props.showLoading();
                let $this = this;
                $this.props.verificarEmail(email);
                this.setState({bloqueado: false});
            }
        }
    }
    handleBlur = (event) => {
        let mail = event.target.value;
        this.setState({email: mail});
        this.setState({inputActive: mail ? "input-active" : ""});
        this.setState({error: false});
        this.props.clearError();
        let email = event.target.value;
        if(email.length >1 && !this.validateEmail(email)) {
            this.setState({error: true});
            this.setState({errorMsj: "El correo electrónico no es válido. Favor de verificar."});
            this.setState({bloqueado: false});
        }
    }
    handleFocus = (event) => {
        this.setState({inputActive: "input-active"});
        this.setState({errorMsj: ""});
        //event.target.value = this.state.error ? "" : event.target.value;
        this.setState({error: false});
        this.props.clearError();
        let email = event.target.value;
        if(email.length >1 && !this.validateEmail(email)) {
            this.setState({error: true});
            this.setState({errorMsj: "El correo electrónico no es válido. Favor de verificar."});
            this.setState({bloqueado: false});
        }
    }
    regresar = () => {
        let mensaje = {"return": "login", "procesa": "recupera"};
        movil("cambiarcontrasena", mensaje);
        window.location.href = '/#!/login';
    }
    _handleKeyPress = (event) => {
        if(this.state.error) {
            this.setState({error: false});
            this.setState({errorMsj: ""});
        }
        if (event.key === 'Enter') {
            console.log("Entro al enter 1")
            if(!this.state.bloqueado) {
                this.setState({bloqueado: true});
                this.setState({checkFlag: true});
                this.validarEmail(); 
            }
        }
    }
    handleChange = (event) => {
        let email = event.target.value;
        if(this.state.checkFlag) {
            if(!this.validateEmail(email)) {
                this.setState({error: true});
                this.setState({errorMsj: "El correo electrónico no es válido. Favor de verificar."});
            } else {
                this.setState({error: false});
                this.setState({errorMsj: ""});
            }
        }
    }
	
	render() {
        return <div className="login-form">
            <div className="text-center">
                { !isMobile.any &&
                <a onClick={this.regresar} className="pull-left">
                    <img src={ require("../img/arrow-back.png") } alt="" />
                </a>
                }
                <img src={ require("../img/logo-gnp.svg") } alt="" />
            </div>
            <h3>Problema para iniciar sesión</h3>
            <div className="mt-25 text-center texto-17">
                <p>
                    Proporciona el siguiente dato y recibirás un correo electrónico <br className="hide-mobile" />con los pasos a seguir para ingresar a tu información.
                </p>
            </div>
            <div className={this.state.inputClass}>
                <label htmlFor="">Correo electrónico</label>
                <span className={this.state.inputActive}>
                    <input ref="email" type={this.state.inputType} onBlur={this.handleBlur} onFocus={this.handleFocus} onKeyPress={this._handleKeyPress} onChange={this.handleChange} />
                </span>
                { this.state.error && 
                    <div className="error-wrap">
                        <div className="msj-error">
                            <p> {this.state.errorMsj}</p>
                        </div>
                    </div>
                }
                { this.props.error && 
                    <div className="error-wrap">
                        <div className="msj-error">
                            <p> {this.props.mensaje}</p>
                        </div>
                    </div>
                }
                <button className="btn-ojo" onClick={this.changeInputType} ></button>
            </div>
            <button onClick={this.validarEmail} disabled={this.state.bloqueado} className="orange-circle">
                <i></i>
            </button>
        </div>
	}
}

export default connect(mapState, mapDispatch)(IngresaCorreo);


// WEBPACK FOOTER //
// ./src/olvide/ingresaCorreo.cmpt.js